// Our brand animation component
const OurBrandAnimation = () => {
    // Getting motion
    const { inView } = Motion;

    // Animation
    const animation = (element) => {
        element.classList.add('centerAnimate');
    };

    // On scroll
    inView(".ourBrandSection", animation);
};

// Export component
export default OurBrandAnimation;